import { API_BASE_URL } from "../../config";

// Put a customer on a route (สาย). The route is stored in customer_buy_rutine (customer x seller),
// the same table the ลูกค้าประจำสาย page and the customer list read, so every screen that sets or
// shows a customer's route must go through this endpoint.
export const DEFAULT_DELIVERY_LEVEL = 2;

export async function assignCustomerToRoute(token, customerId, sellerId, deliveryLevel = DEFAULT_DELIVERY_LEVEL) {
    const response = await fetch(`${API_BASE_URL}/customer/api/customer-buy-rutine/delivery-level/update`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({ customerId, sellerId, deliveryLevel }),
    });
    if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
    }
    return response.json();
}

// by-category answers { regular: [], walkIn: [], agent: [], potential: [] } (an object, not an array).
export function regularCustomersFromByCategory(data) {
    return Array.isArray(data?.regular) ? data.regular : [];
}
